<template>
	<ul class="FieldErrors" >
		<li v-for="tidied_error in errors">{{ tidied_error }}</li>
	</ul>
</template>

<script>

	import { computed } from "vue";

	export default {

		props:['errors'],

		computed:{
			tidied_errors(){
				return this.errors.map(x=>x.trim()).filter(x=>!!x);
			}
		}
	}

</script>